import { Suspense } from 'react'
import DeprecatedGlobalFonts from '@ui-components/fonts'
import GlobalFonts from '@web-ui-kit/fonts'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ConnectedRouter } from 'connected-react-router'
import ReactDOM from 'react-dom'
import Modal from 'react-modal'
import { Provider } from 'react-redux'

import App from 'app'
import GlobalStyle from 'assets/styles'
import { store, history } from 'config/configureStore'
import httpMiddleware from 'config/httpMiddleware'

import './config/i18n'
import { SnackBarFeedbackProvider } from 'context/snackbarFeedback'
import GrafanaFaro from 'components/GrafanaFaro'
import Loader from 'app/components/Loader'
import { queryClient } from 'config/reactQuery'

httpMiddleware()

Modal.setAppElement('#root')
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <SnackBarFeedbackProvider>
        <GlobalStyle />
        <DeprecatedGlobalFonts />
        <GlobalFonts />
        <GrafanaFaro>
          <ConnectedRouter history={history}>
            <Suspense fallback={<Loader />}>
              <App />
            </Suspense>
          </ConnectedRouter>
        </GrafanaFaro>
      </SnackBarFeedbackProvider>
    </Provider>
    <ReactQueryDevtools />
  </QueryClientProvider>,
  document.getElementById('root')
)
